<template>
    <div class="partenaires py-5--5">
        <img src="../assets/img/partenaires/fond-partenaires.svg" class="partenaires--bg" alt="" />

        <h2 class="text-center fw-bold">Nos partenaires pour la REF21 édition 2023</h2>
        <div class="container my-5">
            <div class="d-flex justify-content-around flex-wrap align-items-center w-100 mt-4 gap-5--5">
                <img
                    v-for="(logo, i) in logoList.large"
                    v-bind:key="i"
                    :src="logo.url"
                    style="max-height: 9rem"
                    :class="logo.class"
                    class="mw-100"
                    alt=""
                />
            </div>

            <div class="d-flex justify-content-around flex-wrap align-items-center w-100 my-5 gap-5--5">
                <img
                    v-for="(logo, i) in logoList.medium"
                    v-bind:key="i"
                    :src="logo.url"
                    style="max-height: 6rem"
                    :class="logo.class"
                    class="mw-100"
                    alt=""
                />
            </div>

            <div class="d-flex justify-content-around flex-wrap align-items-center w-100 my-5 gap-5--5">
                <img
                    v-for="(logo, i) in logoList.small"
                    v-bind:key="i"
                    :src="logo.url"
                    style="max-height: 3rem"
                    :class="logo.class"
                    class="mw-100"
                    alt=""
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        logoList() {
            var result = { small: [], medium: [], large: [] };

            var logos = require.context("@/assets/img/partenaires/logos/");

            logos
                .keys()
                .sort()
                .forEach((logo) => {
                    logo = logo.split(/\//)[1];
                    var size = logo.split(/-/)[1];

                    var getLogoUrl = () => require(`@/assets/img/partenaires/logos/${logo}`);
                    if (size == 1) result.large.push({ url: getLogoUrl(), class: logo.split(/\./)[0] });
                    if (size == 2) result.medium.push({ url: getLogoUrl(), class: logo.split(/\./)[0] });
                    if (size == 3) result.small.push({ url: getLogoUrl(), class: logo.split(/\./)[0] });
                });

            return result;
        },
    },
};
</script>

<style scoped>
/* Andre */
.logo-1-01 {
    max-height: 12rem !important;
}

.logo-2-04 {
    max-height: 7rem !important;
}

/* Malakoff + GSC */
.logo-2-06, .logo-2-07 {
    max-height: 7rem !important;
}

/* Ecole des metiers */
.logo-3-00 {
    max-height: 4rem !important;
}
/* UIMM */
.logo-3-04 {
    max-height: 4rem !important;
}
/* vyv */
.logo-3-05 {
    max-height: 5rem !important;
}

/* Reseau entreprendre */
.logo-3-09 {
    max-height: 4.5rem !important;
}

/* Dijon Bourgogne invest */
.logo-3-09_ {
    max-height: 3.5rem !important;
}

/* Region bourgogne */
.logo-3-10 {
    max-height: 3.5rem !important;
}

/* Biacceli */
.logo-3-16 {
    max-height: 4rem !important;
}
</style>
